export default "__VITE_ASSET__CL$HxiN8__"